import { render } from "./IfkMobile.vue?vue&type=template&id=3f4a4032&scoped=true"
import script from "./IfkMobile.vue?vue&type=script&lang=js"
export * from "./IfkMobile.vue?vue&type=script&lang=js"

import "./IfkMobile.vue?vue&type=style&index=0&id=3f4a4032&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3f4a4032"

export default script